import { render } from "./TooltipFrame.vue?vue&type=template&id=489d86be&scoped=true"
import script from "./TooltipFrame.vue?vue&type=script&lang=js"
export * from "./TooltipFrame.vue?vue&type=script&lang=js"

import "./TooltipFrame.vue?vue&type=style&index=0&id=489d86be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489d86be"]])

export default __exports__